import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer, { initialState } from './reducers/index';
var composeEnhancers = process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;
var enhancers = composeEnhancers(applyMiddleware(thunk));
var store = createStore(rootReducer, initialState, enhancers);
export default store;
